/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useEffect, useState } from 'react';
import { Form, message, Modal } from 'antd';
import { PATH_URL } from '@common/config/pathURL';
import { useNavigate } from 'react-router-dom';
import authApi from '@services/auth';
import { useDispatch, useSelector } from 'react-redux';
import { authStore, logoutSuccess } from '@store/slices/authSlice';
import { t } from 'i18next';

function ManageLicense() {
  return (
    <div className="full-height isplay-flex flex-column color-page pt-50">
      <div className="ml-100  mr-100 license">
        <div className="pl-30 pr-30 all-page">
          <div className="pt-15">Feather Icons</div>
          <div className="pt-15">The MIT License (MIT)</div>
          <div className="pt-15">Copyright (c) 2013-2017 Cole Bemis </div>
          <div className="text1 mt-10">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            the Software, to deal in the Software without restriction, including
            without limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions
          </div>
          <div className="text2 mt-10">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </div>
          <div className="text3  mt-10">
            THE SOFTWARE IS PROVIDED AS IS, WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageLicense;
